/**
 * Dev-only logger utility
 *
 * Vite replaces `import.meta.env.DEV` at build time, so production builds
 * tree-shake all logging calls to no-ops (zero runtime cost).
 */

function createLogger(prefix: string) {
  const fmt = (msg: string) => `[${prefix}] ${msg}`;

  if (!import.meta.env.DEV) {
    return {
      log: (..._args: unknown[]) => {},
      warn: (..._args: unknown[]) => {},
      error: (..._args: unknown[]) => {},
    };
  }

  return {
    log: (msg: string, ...args: unknown[]) => console.log(fmt(msg), ...args),
    warn: (msg: string, ...args: unknown[]) => console.warn(fmt(msg), ...args),
    error: (msg: string, ...args: unknown[]) => console.error(fmt(msg), ...args),
  };
}

export const authLogger = createLogger('Auth');
export const amplifyLogger = createLogger('Amplify');
